/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {MixedWidget10, MixedWidget11} from '../../../_metronic/partials/widgets'
import FuturesCard from './DashboardWrapper/FuturesCard'
import {MDBCol, MDBRow} from 'mdb-react-ui-kit'
import Support from '../../../_metronic/partials/widgets/mixed/Support'
import './DashboardWrapper.css'

const MixedWidget2 = React.lazy(
  () => import('../../../_metronic/partials/widgets/mixed/MixedWidget2')
)
const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}
    <MDBRow className={'mb-5'}>

      <MDBCol className="MixedWidget11">
        <MixedWidget11 className=' mb-xl-8 MixedWidget11lap' chartColor='' chartHeight='' />
      </MDBCol>

      <MDBCol lg={'8'}>
        <MixedWidget2
          className='card-xl-stretch mb-xl-8'
          chartColor='danger'
          chartHeight='200px'
          strokeColor='#cb1e46'
        />
      </MDBCol>

      <MDBCol lg={'4'}>
        <MixedWidget11 className=' mb-xl-8 MixedWidget11mob' chartColor='  ' chartHeight='' />

        <MixedWidget10
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='150px'
        />
        <Support className='card-xxl-stretch-50 mb-5 mb-xl-8' />
      </MDBCol>
    </MDBRow>

    {/* </div> */}
    <div className={'justify-center ml-4'} style={{width: '98%'}}>
      <FuturesCard />
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
